import { toast } from 'react-toastify'

import api from '../lib/api'

export const READ_SUMMARY_SUCCESS = 'READ_SUMMARY_SUCCESS'
export const READ_SUMMARY_FAILURE = 'READ_SUMMARY_FAILURE'

export const readSummary = () => async dispatch => {
  try {
    const { data } = await api.get('/api/summary')
    dispatch({ type: READ_SUMMARY_SUCCESS, data })
  } catch (err) {
    toast.error('Failed to retrieve the summary.')
    console.log(err.msg)
    dispatch({ type: READ_SUMMARY_FAILURE, err })
  }
}


// WEBPACK FOOTER //
// ./src/actions/summary.js